import React, { Component } from 'react'
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import FomeList from './FomeList';
import { Button, Icon, Tooltip, message } from 'antd';


export default class QuotationParams extends Component {
    state = {
        params: {},
        type: 'view',
        canEdit: false,
    }

    componentDidMount() {
        const { clinicalQuotationRecordId } = this.props;
        this.loadData(clinicalQuotationRecordId);
    }

    componentWillReceiveProps(nextProps) {
        const { clinicalQuotationRecordId } = nextProps;
        const { params: { clinicalQuotationRecordId: oldClinicalQuotationRecordId} } = this.state;
        if(clinicalQuotationRecordId != oldClinicalQuotationRecordId) {
            this.loadData(clinicalQuotationRecordId);
        }
    }

    loadData = (clinicalQuotationRecordId) => {
        if(!clinicalQuotationRecordId) return
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryQuotationParameter,
            data: { clinicalQuotationRecordId },
            dataType: 'json',
            doneResult: res => {
                const { basePriceStatus } = res.data;
                this.setState({
                    params: { ...res.data },
                    canEdit: basePriceStatus == 'FTE',
                })
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params, canEdit } = this.state;
        const arr = [
            'singlePatientPreFilterCount', 
            'singlePatientFilterCount',
            'singlePatientImportCount',
            'singlePatientRandomCount',
            'singlePatientTreatCount',
            'singlePatientNonMedicineCount',
            'singlePatientSafeCount',
            'singlePatientEotCount',
            'singlePatientPhoneCount',
            'singlePatientFeedbackCount',
        ]
        params[key] = value;
        if (canEdit && arr.some(el => el === key)) {
            let sumValue = 0;
            arr.map(el => {
                sumValue = sumValue + params[el];
            });
            params.singlePatientTotalCount = sumValue;
        }
        this.setState({ params });
    }

    submit = () => {
        const { params } = this.state;
        const { clinicalQuotationRecordId } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.updateQuotationDataParameter,
            data: { clinicalQuotationRecordId, ...params },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    type: 'view',
                }, () => this.loadData(clinicalQuotationRecordId));
            }
        };
        $.sendRequest(options);
    }

    handleDomRender = () => {
        const { canEdit } = this.state;
        const Config = [
            {
                label: '试验编号',
                name: 'evaluateSerialNumber',
                type: 'text',
            },
            {
                label: '备注',
                name: 'evaluateSerialNumberRemark',
                type: 'Input',
            },
            {
                label: '试验药物（或器械/试剂）名称',
                name: 'investigationMedicine',
                type: 'text',
            },
            {
                label: '备注',
                name: 'investigationMedicineRemark',
                type: 'Input',
            },
            {
                label: '治疗领域',
                name: 'investigationAreaName',
                type: 'text',
            },
            {
                label: '备注',
                name: 'investigationAreaNameRemark',
                type: 'Input',
            },
            {
                label: '适应症',
                name: 'diseaseName',
                type: 'text',
            },
            {
                label: '备注',
                name: 'diseaseNameRemark',
                type: 'Input',
            },
            {
                label: '研究产品类型',
                name: 'researchProductTypeName',
                type: 'text',
            },
            {
                label: '备注',
                name: 'researchProductTypeNameRemark',
                type: 'Input',
            },
            {
                label: '临床分期',
                name: 'investigationByStageNames',
                type: 'text',
            },
            {
                label: '备注',
                name: 'investigationByStageNamesRemark',
                type: 'Input',
            },
            {
                label: '筛选中心数',
                name: 'filterSiteNum',
                type: 'text',
            },
            {
                label: '备注',
                name: 'filterSiteNumRemark',
                type: 'Input',
            },
            {
                label: '启动中心数',
                name: 'startSiteNum',
                type: 'text',
            },
            {
                label: '备注',
                name: 'startSiteNumRemark',
                type: 'Input',
            },
            {
                label: '首次伦理递交次数/中心',
                name: 'firstEthicSubmitCountSite',
                type: 'text',
            },
            {
                label: '备注',
                name: 'firstEthicSubmitCountSiteRemark',
                type: 'Input',
            },
            {
                label: '伦理更新递交次数/中心',
                name: 'ethicUpdateSubmitCountSite',
                type: 'text',
            },
            {
                label: '备注',
                name: 'ethicUpdateSubmitCountSiteRemark',
                type: 'Input',
            },
            {
                label: 'CRA监查次数/中心',
                name: 'monitorCountSite',
                type: 'text',
            },
            {
                label: '备注',
                name: 'monitorCountSiteRemark',
                type: 'Input',
            },
            {
                label: '筛选病例',
                name: 'filterCaseNum',
                type: 'text',
            },
            {
                label: '备注',
                name: 'filterCaseNumRemark',
                type: 'Input',
            },
            {
                label: '随机病例',
                name: 'randomCaseNum',
                type: 'text',
            },
            {
                label: '备注',
                name: 'randomCaseNumRemark',
                type: 'Input',
            },
            {
                label: '完成病例（考虑脱落后）',
                name: 'totalFinishCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'totalFinishCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者总访视次数',
                name: 'singlePatientTotalCount',
                type: 'text',
            },
            {
                label: '备注',
                name: 'singlePatientTotalCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者预筛访视次数',
                name: 'singlePatientPreFilterCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientPreFilterCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者筛选访视次数',
                name: 'singlePatientFilterCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientFilterCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者导入访视次数',
                name: 'singlePatientImportCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientImportCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者随机访视次数',
                name: 'singlePatientRandomCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientRandomCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者治疗访视次数',
                name: 'singlePatientTreatCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientTreatCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者非用药访视次数',
                name: 'singlePatientNonMedicineCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientNonMedicineCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者安全性随访访视次数',
                name: 'singlePatientSafeCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientSafeCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者EOT访视次数',
                name: 'singlePatientEotCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientEotCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者电话随访访视次数',
                name: 'singlePatientPhoneCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientPhoneCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者计划外访视次数',
                name: 'singlePatientOutPlanCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientOutPlanCountRemark',
                type: 'Input',
            },
            {
                label: '每例受试者回输访视次数',
                name: 'singlePatientFeedbackCount',
                type: canEdit ? 'InputNumber' : 'text',
                typeProperty: {
                    min: 0,
                },
            },
            {
                label: '备注',
                name: 'singlePatientFeedbackCountRemark',
                type: 'Input',
            },
            {
                label: '数据收集介质',
                name: 'dataCollectionMediumName',
                type: 'text',
            },
            {
                label: '备注',
                name: 'dataCollectionMediumNameRemark',
                type: 'Input',
            },
            {
                label: 'SAE数量',
                name: 'saeNum',
                type: 'text',
            },
            {
                label: '备注',
                name: 'saeNumRemark',
                type: 'Input',
            },
            {
                label: '是否需要预筛服务',
                name: 'needPreFilterService',
                type: 'text',
            },
            {
                label: '备注',
                name: 'needPreFilterServiceRemark',
                type: 'Input',
            },
            // {
            //     label: '是否需要协助研究中心申报遗传办审批服务',
            //     name: 'needGeneticManagerOfficeService',
            //     type: 'text',
            // },
            // {
            //     label: '备注',
            //     name: 'needGeneticOfficeServeRemark',
            //     type: 'Input',
            // },
            {
                label: '是否需要非盲服务',
                name: 'needNonBlindServe',
                type: 'text',
            },
            {
                label: '备注',
                name: 'needNonBlindServeRemark',
                type: 'Input',
            },
            {
                label: '受试者影像信息资料',
                name: 'patientImagingData',
                type: 'text',
            },
            {
                label: '备注',
                name: 'patientImagingDataRemark',
                type: 'Input',
            },
            {
                label: '数据清理次数（阶段性）',
                name: 'dataCleanCountStage',
                type: 'text',
            },
            {
                label: '备注',
                name: 'dataCleanCountStageRemark',
                type: 'Input',
            },
            {
                label: '数据清理次数（锁库）',
                name: 'dataCleanCountLock',
                type: 'text',
            },
            {
                label: '备注',
                name: 'dataCleanCountLockRemark',
                type: 'Input',
            },
            {
                label: '是否有中心实验室',
                name: 'haveCentralLab',
                type: 'text',
            },
            {
                label: '备注',
                name: 'haveCentralLabRemark',
                type: 'Input',
            },
            {
                label: '是否需要中心病理',
                name: 'needSitePathology',
                type: 'text',
            },
            {
                label: '备注',
                name: 'needSitePathologyRemark',
                type: 'Input',
            },
            {
                label: '是否需要中心阅片',
                name: 'needSiteReview',
                type: 'text',
            },
            {
                label: '备注',
                name: 'needSiteReviewRemark',
                type: 'Input',
            },
            {
                label: '密集PK采血次数',
                name: 'needConcentratedPkCollectBloodNum',
                type: 'text',
            },
            {
                label: '备注',
                name: 'concentratedPkCollectBloodNumRemark',
                type: 'Input',
            },
            {
                label: '是否需要CRC协助扫描和上传eTMF',
                name: 'useETmf',
                type: 'text',
            },
            {
                label: '备注',
                name: 'useETmfRemark',
                type: 'Input',
            },
            {
                label: '是否需要CRC协助患者报销或赔偿流程',
                name: 'needCrcAssistReimburse',
                type: 'text',
            },
            {
                label: '备注',
                name: 'needCrcAssistReimburseRemark',
                type: 'Input',
            },
            {
                label: '是否涉及基因检测',
                name: 'involvingGeneticTesting',
                type: 'text',
            },
            {
                label: '备注',
                name: 'involvingGeneticTestingRemark',
                type: 'Input',
            },
            {
                label: '研究周期（估计时间）',
                name: 'researchCycle',
                type: 'text',
            },
            {
                label: '备注',
                name: 'researchCycleRemark',
                type: 'Input',
            },
            {
                label: '准备期（月）',
                name: 'preparePeriod',
                type: 'text',
            },
            {
                label: '备注',
                name: 'preparePeriodRemark',
                type: 'Input',
            },
            {
                label: '入组期（月）',
                name: 'joinGroupPeriod',
                type: 'text',
            },
            {
                label: '备注',
                name: 'joinGroupPeriodRemark',
                type: 'Input',
            },
            {
                label: '治疗期（月）',
                name: 'treatmentPeriod',
                type: 'text',
            },
            {
                label: '备注',
                name: 'treatmentPeriodRemark',
                type: 'Input',
            },
            {
                label: '随访期（月）',
                name: 'followUpPeriod',
                type: 'text',
            },
            {
                label: '备注',
                name: 'followUpPeriodRemark',
                type: 'Input',
            },
            {
                label: '生存随访期（月）',
                name: 'survivalFollowUpPeriod',
                type: 'text',
            },
            {
                label: '备注',
                name: 'survivalFollowUpPeriodRemark',
                type: 'Input',
            },
            {
                label: 'DBL（月）',
                name: 'dbl',
                type: 'text',
            },
            {
                label: '备注',
                name: 'dblRemark',
                type: 'Input',
            },
            {
                label: '关中心（月）',
                name: 'closeSite',
                type: 'text',
            },
            {
                label: '备注',
                name: 'closeSiteRemark',
                type: 'Input',
            },
            {
                label: 'CRC单价（元/FTE）',
                name: 'crcHourUnitPrice',
                type: 'text',
            },
            {
                label: '备注',
                name: 'crcHourUnitPriceRemark',
                type: 'Input',
            },
            {
                label: 'PM单价（元/FTE）',
                name: 'pmHourUnitPrice',
                type: 'text',
            },
            {
                label: '备注',
                name: 'pmHourUnitPriceRemark',
                type: 'Input',
            },
            {
                label: 'CRC服务预计启动时间',
                name: 'crcServicePlanStartTime',
                type: 'text',
            },
            {
                label: '备注',
                name: 'crcServicePlanStartTimeRemark',
                type: 'Input',
            },
        ]

        const { params } = this.state;
        const { redList  = [] } = params;
        Config.map(el => {
            el.isRed = redList.find( redData => redData == el.name );
        })
        return Config
    }

    render() {
        const { params, type } = this.state;
        const { clinicalQuotationRecordId, recordData } = this.props;
        const { bdBaAuth, evaluateStatus } = recordData;
        return (
            <div>
                <div style={{ fontSize: 20, fontWeight: 600, textAlign: 'center', margin: '20px 0' }}>
                    项目信息表
                    <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'申明：请申办方确认信息无误，参数均影响预算'}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </div>
                <FomeList
                    params={params}
                    updateType={type}
                    handleChange={this.handleChange}
                    DomConfig={this.handleDomRender()}
                />
                { 
                    (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') && <div className='Forecast_Params_footer'>
                        {
                            type === 'view'?
                            <Button 
                                type="primary"
                                onClick={() => this.setState({
                                    type: 'edit',
                                })}
                            >编辑</Button> :
                            <div>
                                <Button 
                                    style={{ marginRight: 20 }}
                                    onClick={() => this.setState({
                                        type: 'view',
                                    }, () => this.loadData(clinicalQuotationRecordId))}
                                >取消</Button>
                                <Button 
                                    type="primary"
                                    onClick={this.submit}
                                >确定</Button>
                            </div>
                        }
                    </div>
                }
            </div>
            
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/QuotationParams.js